import { useStore } from 'zustand';
import { persist } from 'zustand/middleware';
import { createStore } from 'zustand/vanilla';

const MAX_RECENT_TECHNOLOGIES = 5;

const initialState = {
  recentTechnologiesCollapsed: false,
  recentTechnologyIds: [] as string[],
};

export type SidebarStore = {
  recentTechnologiesCollapsed: boolean;
  recentTechnologyIds: string[];

  // Actions
  addRecentTechnology: (technologyId: string) => void;
  removeRecentTechnology: (technologyId: string) => void;
  reset: () => void;
  setRecentTechnologiesCollapsed: (collapsed: boolean) => void;
};

export const sidebarStore = createStore<SidebarStore>()(
  persist(
    (set) => ({
      ...initialState,

      addRecentTechnology: (technologyId) =>
        set((state) => {
          const filteredIds = state.recentTechnologyIds.filter((id) => id !== technologyId);
          const newRecentIds = [technologyId, ...filteredIds].slice(0, MAX_RECENT_TECHNOLOGIES);
          return { recentTechnologyIds: newRecentIds };
        }),

      removeRecentTechnology: (technologyId) =>
        set((state) => ({
          recentTechnologyIds: state.recentTechnologyIds.filter((id) => id !== technologyId),
        })),

      reset: () => set(initialState),

      setRecentTechnologiesCollapsed: (collapsed) => set({ recentTechnologiesCollapsed: collapsed }),
    }),
    {
      name: 'sidebarStore',
    },
  ),
);

export const useSidebarStore = (): SidebarStore => useStore(sidebarStore);
